import { ParamIds, Places } from '../../Constants'
import { MainKeys } from '../../main/Main.keys'
import type { FilterCatalogFormMode } from '../the-consumer-market/tcm_scopes'
import type { AnaliseDesempenhoPresenter } from './ad_presenter'

const presenterUUID = '8f3a61d2c4b7'

export class AnaliseDesempenhoKeys extends MainKeys {
    get place() {
        return Places.analiseDesempenho
    }

    get adPresenter() {
        return this._intent.attributes.get(presenterUUID) as AnaliseDesempenhoPresenter
    }

    set adPresenter(value: AnaliseDesempenhoPresenter) {
        this._intent.attributes.set(presenterUUID, value)
    }
}

export class AdFilterCatalogFormKeys extends AnaliseDesempenhoKeys {
    get place() {
        return Places.analiseDesempenho_FilterCatalogForm
    }

    setMode(mode: FilterCatalogFormMode) {
        this._intent.setParameter(ParamIds.tcmFilterFormMode, mode)
        return this
    }

    get mode(): FilterCatalogFormMode {
        return (this._intent.getParameterAsString(ParamIds.tcmFilterFormMode) ?? 'create') as FilterCatalogFormMode
    }

    setSourceId(id: string) {
        this._intent.setParameter(ParamIds.tcmFilterSourceId, id)
        return this
    }

    get sourceId(): string {
        return this._intent.getParameterAsString(ParamIds.tcmFilterSourceId) ?? ''
    }
}

export class AdFilterCatalogShareKeys extends AnaliseDesempenhoKeys {
    get place() {
        return Places.analiseDesempenho_FilterCatalogShare
    }

    setSourceId(id: string) {
        this._intent.setParameter(ParamIds.tcmFilterSourceId, id)
        return this
    }

    get sourceId(): string {
        return this._intent.getParameterAsString(ParamIds.tcmFilterSourceId) ?? ''
    }
}

export default AnaliseDesempenhoKeys
